import { axiosInstance } from 'api/apiConfig'
import { useLayoutEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import { loadingState, sideMenuState } from 'store/atom/app-state-atom'
import useModal from 'hook/useModal'
import { decrypt } from 'utils/crypto-util'
import { APP_INFO_CONST } from 'constants/app_info_const'
import useCommon from 'hook/useCommon'
import { App as Application } from 'native/core-plugin'

const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate()
  const { alertModal, closeModalAll } = useModal()
  const { removeUserInfo } = useCommon()

  const setLoadingState = useSetRecoilState(loadingState)
  const setSideMenuState = useSetRecoilState(sideMenuState)

  const notLoading = ['/user/refreshToken', '/api/main/menusearch/v1.0/kwrdSrchAutoPerf']

  // 갱신 최적화
  const onLoading = (flag) => {
    setLoadingState((prevState) => ({
      ...prevState,
      isLoading: flag,
    }))
  }

  let reqList = []

  const addReqList = (url) => {
    if (reqList.indexOf(url) === -1) {
      reqList = [...reqList, url]
    }
    onLoading(true)
  }

  const removeReqList = (url) => {
    if (reqList.length > 0 && reqList.indexOf(url) > -1) {
      reqList.splice(reqList.indexOf(url), 1)
    }
    if (reqList.length === 0) {
      onLoading(false)
    }
  }

  const clearReqList = () => {
    reqList = []
    onLoading(false)
  }

  useLayoutEffect(() => {
    axiosInstance.interceptors.request.use(
      (config) => {
        console.log('================= AXIOS REQUEST ==================')
        console.log(config)
        console.log('==================================================')
        if (notLoading.indexOf(config.url) === -1) {
          addReqList(config.url)
          //onLoading(true)
        }

        config.headers.Authorization = `Bearer ${decrypt(localStorage.getItem(APP_INFO_CONST.TOKEN_KEY))}`

        return config
      },
      (error) => {
        //onLoading(false)
        clearReqList()
        alert(error)
        alertModal('서버에서 에러가 발생하였습니다.', closeModalAll)
        //return new Promise(() => {})
        //return Promise.reject(error)
      },
    )

    axiosInstance.interceptors.response.use(
      (response) => {
        console.log('================ AXIOS RESPONSE ==================')
        console.log(response)
        console.log('==================================================')
        removeReqList(response.config.url)
        //onLoading(false)

        //파일 다운로드
        if (response.data instanceof Blob) {
          return response
        }

        return response
      },
      (error) => {
        console.log('================ AXIOS ERROR ==================')
        console.log(error)
        console.log('==================================================')
        //onLoading(false)
        clearReqList()

        if (error.message.indexOf('timeout') > -1) {
          alertModal('서버에서 응답이 지연되었습니다.', closeModalAll)
          return new Promise(() => {})
        } else if (error.message.indexOf('Network') > -1) {
          alertModal('서버에서 에러가 발생하였습니다.<br/>앱을 종료합니다.', () => {
            closeModalAll()
            try {
              Application.finish()
            } catch {}
          })
          return new Promise(() => {})
        } else if (error.response.status === 401) {
          setSideMenuState({ isOpen: false })
          removeUserInfo()
          if (window.location.pathname === '/') {
            navigate('/login')
          } else {
            let message =
              error.response.data.message && error.response.data.message !== 'AUTH_IS_NULL'
                ? error.response.data.message
                : '인증이 만료되었습니다. <br/>다시로그인해주세요.'
            alertModal(message, () => {
              closeModalAll()
              navigate('/login')
            })
          }

          return new Promise(() => {})
        } else if (error.response.status === 500) {
          let message = error.response.data.message ? error.response.data.message : '서버에서 에러가 발생하였습니다.'
          alertModal(message, closeModalAll)
          return Promise.reject(error)
        } else {
          return Promise.reject(error)
        }
      },
    )
  }, [])

  return children
}

export { AxiosInterceptor }
